/**
 * CMS API client (Laravel REST API).
 *
 * Production / Laravel: REACT_APP_CMS_API=/api (same origin, port 8000).
 * When unset (static Hostinger deploys), skip network calls and use bundled
 * defaultContent. Example remote: REACT_APP_CMS_API=https://example.com/api
 */
const API_BASE = (process.env.REACT_APP_CMS_API || "").replace(/\/$/, "");
const CMS_ENABLED = Boolean(API_BASE);

async function parseJson(res) {
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || `Request failed (${res.status})`);
  return data;
}

/** @returns {Promise<object|null>} null = use bundled defaults */
export async function fetchContent() {
  if (!CMS_ENABLED) return null;
  const res = await fetch(`${API_BASE}/content`);
  return parseJson(res);
}

export async function submitForm(type, payload) {
  if (!CMS_ENABLED) {
    // Soft success so forms don't hard-fail on static hosting
    console.info("[cms] Form submission skipped — CMS API not configured.");
    return { ok: true, offline: true };
  }
  const res = await fetch(`${API_BASE}/submissions`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ type, ...payload }),
  });
  return parseJson(res);
}

export async function fetchPageBySlug(slug) {
  if (!CMS_ENABLED) {
    const err = new Error("NOT_FOUND");
    err.code = "NOT_FOUND";
    throw err;
  }
  const res = await fetch(`${API_BASE}/pages/by-slug/${encodeURIComponent(slug)}`);
  if (res.status === 404) {
    const err = new Error("NOT_FOUND");
    err.code = "NOT_FOUND";
    throw err;
  }
  return parseJson(res);
}

export { API_BASE, CMS_ENABLED };
